<template>
  <div
    ref="wfSelect"
    class="tail-select w-full hide-selected hide-disabled multiple border-theme-8"
    :class="{ active: show }"
  >
    <div
      class="select-label tail-select-container"
      :class="{ 'select-label-invalid': props.invalid }"
      @click.stop="showList"
    >
      <span class="label-inner" v-if="!selected.title">-- Select --</span>
      <div v-else class="" data-group="#">
        <button
          class="bg-gray-500 text-white px-1  rounded-full text-xs"
          @click.prevent="clearSelected"
          v-show="props.showBtnClear"
        >
          X
        </button>
        {{ selected.title }}
      </div>
    </div>

    <div
      class="select-dropdown relative"
      style="max-height 348px; height: auto; display: block; overflow: visible;"
      v-show="show"
    >
      <div class="dropdown-search">
        <input
          type="text"
          autofocus
          ref="searchInputRef"
          v-model.trim="searchInput"
          @keydown.esc="searchClear"
          class="search-input"
          placeholder="Type in serach... 3 charactor"
        />
      </div>
      <div class="text-center" v-show="searchLoading">
        <div class="m-auto my-4 w-8 h-8">
          <LoadingIcon icon="oval" color="gray" class="w-4 h-4 mr-2" />
        </div>
      </div>
      <div class="dropdown-inner">
        <ul class="dropdown-optgroup relative" style="max-height: 300px;">
          <li
            class="dropdown-option"
            v-for="item in items"
            :key="item.vendor_code"
            @click="handleSelected(item)"
          >
            <div class="font-bold">
              ({{ item.vendor_code }}) {{ item.vendor_name }}
            </div>
            {{ item.vendor_address }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  onUpdated,
  onMounted,
  watch
} from 'vue'
import { api } from '../../utils/api'
import useDebouncedRef from '../../helpers/useDebouncedRef'
export default defineComponent({
  props: {
    modelKey: {
      type: String
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    modelValue: {
      type: [Object, Number, String],
      validator(value) {
        // console.log('valid: ', value)
        return value.toString()
      },
      default() {
        return null
      }
    },
    invalid: {
      type: Boolean,
      default() {
        return false
      }
    },
    showBtnClear: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const show = ref(false)
    const searchInput = useDebouncedRef(null, 1000)
    const searchInputRef = ref(null)
    const searchLoading = ref(false)
    const showList = async () => {
      show.value = !show.value
      searchInput.value = ''
    }
    onUpdated(() => {
      searchInputRef.value.focus()
    })

    const items = ref([])
    watch(searchInput, (newVal, oldVal) => {
      if (newVal.length >= props.options.searchMinLength) {
        searchLoading.value = true
        const perPage = props.options.ajaxLimit || 50
        api
          .get(`/admin/vendor/all?per_page=${perPage}&search=${newVal}`)
          .then(res => {
            searchLoading.value = false
            items.value = res.data.data
          })
      } else {
        searchLoading.value = false
      }
    })

    const itemSelected = reactive([])
    const selected = reactive({
      title: '',
      value: null
    })

    const init = () => {
      if (props.modelValue) {
        api
          .get(`/admin/vendor/getByVendorCode/${props.modelValue}`)
          .then(res => {
            if (res.code == 200) {
              selected.title = `(${res.data.vendor_code}) ${res.data.vendor_name}`
              selected.value = res.data.vendor_code
              context.emit('update:modelValue', res.data)
            }
          })
      }
    }
    const handleSelected = item => {
      // console.log('item: ', item)
      selected.title = `(${item.vendor_code}) ${item.vendor_name}`
      selected.value = item.vendor_code
      context.emit('update:modelValue', item)
      showList()
    }
    const searchClear = () => {
      searchInput.value = ''
    }

    const clearSelected = () => {
      selected.title = ''
      selected.value = null
      show.value = true
      context.emit('update:modelValue', null)
    }

    watch(
      () => props.modelValue,
      newVal => {
        // console.log('watch: ', props.modelValue)
        if (newVal === null) {
          selected.title = ''
          selected.value = null
        } else {
          // console.log('typeof: ', typeof props.modelValue)
          if (
            typeof props.modelValue == 'number' ||
            typeof props.modelValue == 'string'
          ) {
            init()
          }
        }
      }
    )

    onMounted(() => {
      init()
    })

    return {
      props,
      show,
      showList,
      searchInput,
      searchInputRef,
      items,
      itemSelected,
      handleSelected,
      searchClear,
      selected,
      searchLoading,
      clearSelected
      //   wfSelect
    }
  }
})
</script>

<style scoped>
.select-label-invalid {
  border-color: #ff0000;
}
</style>
